import { h } from 'preact';

import { links } from '../../constants';

import { Title } from '../../components/title';
import { ButtonCta } from '../../components/button';
import { Section } from '../../components/Grid';

import basic from '../../../assets/images/basic.svg';
import full from '../../../assets/images/full.svg';
import dmBasic from '../../../assets/images/basic.dm.svg';
import dmFull from '../../../assets/images/full.dm.svg';

import { TableRow, ExpandableTableRow } from './TableRow';
import { Footnote } from '../../shared/Footnotes';

const ComparePlans = () => (
    <Section>
        <header className="u-text-center">
            <Title className="u-txt-purple-100 dark:u-txt-purple-30">Compare plans</Title>
        </header>
        <div className="c-compare-plans u-mb-12">
            <div className="c-compare-plans__header">
                <div className="is-empty" />
                <div>
                    <picture>
                        <source srcSet={basic} media={'(prefers-color-scheme: light)'} />
                        <source srcSet={dmBasic} media={'(prefers-color-scheme: dark)'} />
                        <img src={basic} width="40" height="40" alt="" />
                    </picture>
                    Unlimited Basic
                </div>
                <div>
                    <picture>
                        <source srcSet={full} media={'(prefers-color-scheme: light)'} />
                        <source srcSet={dmFull} media={'(prefers-color-scheme: dark)'} />
                        <img src={full} width="40" height="40" alt="" />
                    </picture>
                    Unlimited Full
                </div>
            </div>
            <TableRow
                title={
                    <>
                        No down payment
                        <Footnote id="1" />
                    </>
                }
                flex
                basic
                full
            />
            <TableRow title="Flexible micropayments" flex basic full />
            <ExpandableTableRow
                title={
                    <>
                        No upfront fees
                        <Footnote id="2" />
                    </>
                }
                flex
                basic
                full
            >
                <p>
                    No upfront fees: we hate fees as much as you do. That’s why with Hugo, if fees
                    occur we let you pay them over time. You’ll never be hit with an upfront fee.
                </p>
            </ExpandableTableRow>
            <ExpandableTableRow title="Overdraft protection" flex basic full>
                <p>
                    Never spend more than what’s in your account. If you can’t make a payment, we
                    understand; you can request to cancel your policy. When you can afford to drive
                    again, reload your account and restart coverage.
                </p>
            </ExpandableTableRow>
            <ExpandableTableRow title="Coverage Extension" flex basic full>
                <p>
                    If your account is empty, and you can’t refill right away, we’ll keep you
                    covered and give you a few extra days to pay
                </p>
            </ExpandableTableRow>
            <ExpandableTableRow full title="Same day claims pay">
                <p>
                    No more checks in the mail or bank transfer delays. When a claim is settled
                    you’ll get paid that same day.
                </p>
            </ExpandableTableRow>
            <TableRow title="Earn cash rewards" flex basic full />
            <TableRow title="Start coverage instantly" flex basic full />
            <TableRow title="Meets state requirements" flex basic full />
            <TableRow title="Covers your vehicle" full />
            <TableRow title="Covers your passengers" full />
        </div>
        <div className="c-plans__cta">
            <ButtonCta icon href={links.QUOTE_FLOW}>
                Get my quote
            </ButtonCta>
            <div className="u-muted u-text-center u-mt-4">
                Sign up and get proof of insurance
                <br /> in under 6 minutes
            </div>
        </div>
    </Section>
);

export default ComparePlans;
